import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:teamId/referral-products(/:view)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/ReferralProductsContainer',
      './modules/referralProducts'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const referralProducts = require('./containers/ReferralProductsContainer').default
      const actions = require('./modules/referralProducts')
      const reducer = require('./modules/referralProducts').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'templateReferralProducts', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId, nextState.params.view))

      /*  Return getComponent   */
      cb(null, referralProducts)

    /* Webpack named bundle   */
    }, 'templateReferralProducts')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/components/ReferralProducts/index.js